(function () {
  function init() {
    const loader = document.getElementById("eo-preloader");
    if (!loader) return; // not homepage (good)

    const bar = document.getElementById("eoBar");

    // start bar
    if (bar) bar.style.width = "0%";

    const start = performance.now();
    const TOTAL_ANIM = 2200;

    let rafId = null;
    function tick(now) {
      const t = Math.min((now - start) / TOTAL_ANIM, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const pct = Math.min(92, Math.round(eased * 92));
      if (bar) bar.style.width = pct + "%";
      if (pct < 92) rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);

    function finish() {
      if (rafId) cancelAnimationFrame(rafId);
      if (bar) bar.style.width = "100%";

      loader.classList.add("is-hidden");
      loader.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        try { loader.remove(); } catch (e) {}
      }, 800);
    }

    window.addEventListener("load", finish, { once: true });
    setTimeout(finish, 4000); // hard safety
    window.addEventListener("pageshow", (e) => { if (e.persisted) finish(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  } 
})();
